import { workerStatus } from "../worker";
import { progress, sendProgress } from "./generalSearchProgress";
import { Result, ResultUnit } from "./generalSearchResult";

const loop = async (
  workerContext: any,
  result: Result,
  run: (e: ResultUnit, i: number) => void
) => {
  let i = 0;
  for (const e of result) {
    if (workerStatus.abort) {
      break;
    }
    ++i;
    progress.get().queryProgress[
      progress.get().queryProgress.length - 1
    ].currentWordCount = i;
    if (i % 1000 === 0) {
      await sendProgress(workerContext);
    }
    run(e, i);
  }
};

// use loop
export const filter = async (
  workerContext: any,
  result: Result,
  condition: (e: ResultUnit, i: number) => boolean
) => {
  const list: Result = [];
  await loop(workerContext, result, (e, i) => {
    if (condition(e, i)) {
      list.push(e);
    }
  });
  return list;
};

export const convertFlat = async (
  workerContext: any,
  result: Result,
  convert: (e: ResultUnit, i: number) => ResultUnit[]
): Promise<Result> => {
  const list: ResultUnit[][] = [];
  await loop(workerContext, result, (e, i) => {
    list.push(convert(e, i));
  });
  const _result = list.flat();
  _result.forEach((e) => {
    e.trace.push(e.currentWord);
  });
  return _result;
};
